import React from "react"
import ReactDOM from "react-dom/client"
import { Tooltip } from "react-tooltip"
import { QueryClientProvider, QueryClient } from "@tanstack/react-query"

import "react-tooltip/dist/react-tooltip.css"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    <Tooltip id="t4ever-tooltip" className="!text-xs !bg-slate-800 z-[100]" place="top" />
  </React.StrictMode>,
)

reportWebVitals()
